import { FetchAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeFetch, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import { Inject } from '@odinjs/odin';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import BaseController from '../../../BaseController';
import { ApplicationRoute } from '../../../../constants/routes';
import { Value } from '@philips-internal/oswald-ui-core';

interface InfusionClickValue {
  dsItem: string;
  ieStatus: string;
  ieTipoItem: string;
  nrEtapas: number;
  nrPrescricao: number;
  nrSequencia: number;
  qtEtapaTotal: number;
}

@Controller({ component: 'ongoing-infusion-layout', fragment: 'ongoing-infusions' })
class OngoingInfusionsController extends BaseController {

  @Inject('fetch-ongoing')
  fieldFetch!: FetchAPI;

  @OnMount({ target: 'ongoing-infusion-layout' })
  onMountOngoing(): void {
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    this.context.set({
      encounterId,
      patientId,
    });

    InformationBarUtils.collapsedBar = true;
  }

  @OnBeforeFetch({ target: ['fetch-ongoing'] })
  onBeforeFetchPhysician(evt: FetchEvent): void {
    if (evt) {
      const { encounterId } = this.historyService.getCurrentRouteParams();
      const params = {
        nrAtendimento: encounterId,
      } as Record<string, Value>;

      this.fieldFetch.setParameters(params);
    }
  }

  @OnClick({ target: 'deck-ongoing' })
  onClickDeckOngoing(evt: ClickEvent): void {
    const value = evt.value as InfusionClickValue;

    const patientId = this.context.get('patientId') as string;
    const encounterId = this.context.get('encounterId') as string;

    const routeParams = {
      encounterId,
      patientId,
      prescriptionNumber: value.nrPrescricao,
      sequenceNumber: value.nrSequencia,
    }

    const route = ApplicationRoute.ADEP_INFUSION_VIEWER;

    applicationContext.redirect(route, routeParams);
  }
}

export default OngoingInfusionsController;